/*
  Cart discount code field.

  Shopify has no Ajax endpoint for discounts, so applying one means hitting
  /discount/CODE, which sets the cart's discount cookie. vm-cart-open.js already does
  that with fetch (window.vmApplyDiscount) for the offer buttons, so the page stays put
  and we repaint the cart from the Section Rendering API afterwards.

  Whether the code actually stuck is read back from the repainted markup rather than
  from the response, because /discount/ answers the same way either way.
*/
(function () {
  if (window.vmCartDiscount) {
    return;
  }

  var MESSAGE_MS = 6000;
  var messageTimer = null;

  function root() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function apply(code) {
    if (typeof window.vmApplyDiscount === 'function') {
      return window.vmApplyDiscount(code);
    }
    return fetch(root() + 'discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      credentials: 'same-origin',
    }).catch(function () {});
  }

  function sectionsUrl(ids) {
    return window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
  }

  function fetchSections(ids) {
    return fetch(sectionsUrl(ids), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) {
        throw new Error('sections request failed');
      }
      return response.json();
    });
  }

  function parse(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  /* Cart page. Swaps the two cart sections in place so the field, the line item
     discounts and the totals all come back consistent. */
  function repaintPage() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!items && !footer) {
      return Promise.resolve(false);
    }

    var ids = [];
    if (items && items.dataset.id) ids.push(items.dataset.id);
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (!ids.length) {
      return Promise.resolve(false);
    }

    return fetchSections(ids).then(function (sections) {
      if (items && items.dataset.id && sections[items.dataset.id]) {
        var freshItems = parse(sections[items.dataset.id], '#main-cart-items');
        if (freshItems) items.innerHTML = freshItems.innerHTML;
      }
      if (footer && footer.dataset.id && sections[footer.dataset.id]) {
        var freshFooter = parse(sections[footer.dataset.id], '#main-cart-footer');
        if (freshFooter) footer.innerHTML = freshFooter.innerHTML;
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        var freshBubble = parse(sections['cart-icon-bubble'], '.shopify-section');
        if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }
      return true;
    });
  }

  /* Cart drawer. renderContents is Dawn's own repaint, so the drawer keeps its state. */
  function repaintDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      return Promise.resolve(false);
    }

    var ids = ['cart-drawer', 'cart-icon-bubble'];
    if (typeof drawer.getSectionsToRender === 'function') {
      ids = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    return fetchSections(ids).then(function (sections) {
      drawer.renderContents({ sections: sections });
      return true;
    });
  }

  function repaint(field) {
    return field.closest('cart-drawer') ? repaintDrawer() : repaintPage();
  }

  /* The old field is gone after a repaint, so find its replacement by context. */
  function refind(inDrawer) {
    var scope = inDrawer ? document.querySelector('cart-drawer') : document;
    if (!scope) {
      return null;
    }
    return scope.querySelector('[data-vm-cart-discount]');
  }

  function message(field, text, kind) {
    if (!field) {
      return;
    }
    var node = field.querySelector('[data-vm-discount-message]');
    if (!node) {
      return;
    }
    clearTimeout(messageTimer);
    /* A repaint hands back a collapsed <details> whenever no code stuck, which would
       hide the very message explaining why. */
    if (field.tagName === 'DETAILS') {
      field.open = true;
    }
    node.textContent = text;
    node.classList.toggle('is-error', kind === 'error');
    node.classList.toggle('is-success', kind === 'success');
    node.hidden = false;
    if (kind === 'success') {
      messageTimer = setTimeout(function () {
        node.hidden = true;
      }, MESSAGE_MS);
    }
  }

  function hasCode(field, code) {
    if (!field) {
      return false;
    }
    var wanted = String(code).toLowerCase();
    var found = false;
    field.querySelectorAll('[data-vm-discount-code]').forEach(function (node) {
      if (node.getAttribute('data-vm-discount-code').toLowerCase() === wanted) {
        found = true;
      }
    });
    return found;
  }

  function busy(field, state) {
    if (!field) {
      return;
    }
    field.classList.toggle('is-busy', !!state);
    var button = field.querySelector('[data-vm-discount-apply]');
    if (button) {
      button.disabled = !!state;
    }
  }

  function submit(field) {
    var input = field.querySelector('[data-vm-discount-input]');
    var code = input ? input.value.trim() : '';
    if (!code) {
      message(field, 'Enter a discount code.', 'error');
      if (input) input.focus();
      return;
    }
    if (hasCode(field, code)) {
      message(field, code + ' is already applied.', 'error');
      return;
    }

    var inDrawer = !!field.closest('cart-drawer');
    busy(field, true);

    apply(code)
      .then(function () {
        return repaint(field);
      })
      .then(function () {
        var fresh = refind(inDrawer) || field;
        busy(fresh, false);
        if (hasCode(fresh, code)) {
          message(fresh, code + ' applied.', 'success');
        } else {
          var freshInput = fresh.querySelector('[data-vm-discount-input]');
          if (freshInput) {
            freshInput.value = code;
            freshInput.focus();
          }
          message(fresh, code + " isn't valid for this cart.", 'error');
        }
      })
      .catch(function () {
        var fresh = refind(inDrawer) || field;
        busy(fresh, false);
        message(fresh, 'Could not apply that code, please try again.', 'error');
      });
  }

  /*
    There is no endpoint for clearing a discount either. Sending a code that cannot
    match anything replaces the stored one, which is the only lever a theme has. If the
    original survives it, say so rather than pretending the click worked.
  */
  function remove(field, code) {
    var inDrawer = !!field.closest('cart-drawer');
    busy(field, true);

    apply('vm-clear-discount')
      .then(function () {
        return repaint(field);
      })
      .then(function () {
        var fresh = refind(inDrawer) || field;
        busy(fresh, false);
        if (hasCode(fresh, code)) {
          message(fresh, 'Could not remove ' + code + '. It can be cleared at checkout.', 'error');
        } else {
          message(fresh, code + ' removed.', 'success');
        }
      })
      .catch(function () {
        var fresh = refind(inDrawer) || field;
        busy(fresh, false);
        message(fresh, 'Could not remove ' + code + ', please try again.', 'error');
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var applyButton = event.target.closest('[data-vm-discount-apply]');
    if (applyButton) {
      event.preventDefault();
      var applyField = applyButton.closest('[data-vm-cart-discount]');
      if (applyField) submit(applyField);
      return;
    }

    var removeButton = event.target.closest('[data-vm-discount-remove]');
    if (removeButton) {
      event.preventDefault();
      var removeField = removeButton.closest('[data-vm-cart-discount]');
      if (removeField) remove(removeField, removeButton.getAttribute('data-vm-discount-remove'));
    }
  });

  /* Enter in the field applies rather than submitting the cart form behind it. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target || !event.target.closest) {
      return;
    }
    if (!event.target.matches('[data-vm-discount-input]')) {
      return;
    }
    event.preventDefault();
    var field = event.target.closest('[data-vm-cart-discount]');
    if (field) submit(field);
  });

  window.vmCartDiscount = { apply: apply, submit: submit };
})();
